// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resendLink:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}", "",{"version":3,"sources":["webpack://src/Screens/Auth/ResetPassword.css"],"names":[],"mappings":"AAAA;EACI,eAAe;EACf,0BAA0B;AAC9B","sourcesContent":[".resendLink:hover {\n    cursor: pointer;\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
